import React, { Component } from 'react'
import SignatureContainer from './signatureContainer';

import SignatureStacked from './signatures/stacked';
import SignatureInline from './signatures/inline';
import SignatureLogoColumn from './signatures/logoColumn';
import SignaturePhoto from './signatures/photo';
import SignatureBlueLine from './signatures/blueLine';

class SignatureResultsContainer extends Component {

	constructor(props){
		super(props);

		this.state = {
			signatureVisible: this.signatureArray()[0]
		}

		this.showSig = this.showSig.bind(this);
	}

	signatureArray(){
		return [
			{ name: "Stacked", id: "stacked", component: SignatureStacked },
			{ name: "Inline",  id: "inline",  component: SignatureInline },
			{ name: "Signature with Logo", id: "twoColumns", component: SignatureLogoColumn},
			{ name: "Signature With Photo", id: "photo", component: SignaturePhoto},
			{ name: "Blue Line", id: "BlueLine", component: SignatureBlueLine}
		]
	}

	getSignatureById(id){
		return this.signatureArray().find(signaure => signaure.id === id);
	}

	showSig(event){
		this.setState({
			signatureVisible: this.getSignatureById(event)
		})
	}

	render(){
        if (this.props.contactInfo.name !== ''){

			const {signatureVisible} = this.state;

            return(
                <div className="row">

					<div className="grid-x">

						<div className="column medium-4">
							<h2>Signature Styles</h2>
							<ul className="signature-menu vertical">
								{
									this.signatureArray().map((signature, id) => {
										return(
											<li key={id}>
												<button onClick={()=>this.showSig(signature.id)}
														className={signatureVisible.id === signature.id ? 'active' : ''}>
													{signature.name}
												</button>
											</li>
										)
									})
								}

							</ul>
						</div>

						<div className="column medium-8">
							<h2>Signature Preview</h2>
							<p>Font sizes will look slightly smaller in the web browser than in Outlook. Use the select/copy button below to copy the signature to your clipboard.</p>
							<SignatureContainer
								contactInfo={this.props.contactInfo}
								sigId={signatureVisible.id}
								disclaimers={this.props.disclaimers}
								logos={this.props.logos}
								component={signatureVisible.component} />


						</div>
					</div>
                </div>
            );
        }else{
            return(
                <div className="row">
					<hr/>
					<div className="column">
					<p>Type your name above to get started</p>
					</div>
				</div>
            )
        }
    }

}

export default SignatureResultsContainer;